/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';

const SuccessActions = (props) => {
  const {
    locationsCountryPath,
  } = props;

  const generateLastLocationLink = () => {
    let lastLocationLink = localStorage.getItem('lastLink');

    if (lastLocationLink) {
        lastLocationLink = lastLocationLink.slice(0, lastLocationLink.lastIndexOf('/')).replace(/"/g, '');
        return lastLocationLink;
    }
    else {
        return null;
    }
  };

  const lastLocationLink = generateLastLocationLink();

  return (
    <div className="thank-you-page__column thank-you-page__actions">
      <a
        href={locationsCountryPath}
        title={I18n.t('generic.office_search')}
        className="button--big-orange stdSubmit"
      >
        {I18n.t('generic.office_search')}
      </a>

      {lastLocationLink && (
        <a
          href={lastLocationLink}
          title={I18n.t('order.back_to_list_view_button')}
          className="button--big-orange stdSubmit"
        >
        {I18n.t('order.back_to_list_view_button')}
        </a>
      )}
    </div>
  );
};

SuccessActions.propTypes = {
  locationsCountryPath: PropTypes.string,
};

SuccessActions.defaultProps = {
  locationsCountryPath: '',
};

export default SuccessActions;
